import React from 'react';
import {Form} from "react-bootstrap";
import useVMStore from "../../../../store";

export default function Page2() {
    const name = 'page2';

    const {data, setData} = useVMStore();

    const _data = data[name];

    function changeData(val: string | number, name: string) {
        const newData = {..._data, [name]: val};
        setData(newData, "page2")
    }

    return (
        <Form className='page-2'>
            <Form.Group>
                <Form.Control placeholder={'Adresse des Projekt'}
                              value={_data.adresseDesProjekt}
                              onChange={(e) => changeData(e.target.value, 'adresseDesProjekt')}
                />
            </Form.Group>
            {/* <div className='d-flex'>
                <Form.Group className='col me-3'>
                    <Form.Control type='number' placeholder={'PLZ'}
                                  value={_data.plz ? _data.plz.replace(/^0+/, '') : ''}
                                  onChange={(e) => changeData(e.target.value, 'plz')}
                    />
                </Form.Group>
                <Form.Group className='col'>
                    <Form.Control placeholder={'Ort'}
                                  value={_data.ort}
                                  onChange={(e) => changeData(e.target.value, 'ort')}
                    />
                </Form.Group>
            </div> */}
            <Form.Group>
                <Form.Control placeholder={'Or Google Address Link'}
                              value={_data.googleAddressLink}
                              onChange={(e) => changeData(e.target.value, 'googleAddressLink')}
                />
            </Form.Group>
        </Form>
    );
}
